import{keyframes as o}from"styled-components";const t=o`
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
`,r=o`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`,a=o`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;export{r as FadeInAnimation,a as FadeOutAnimation,t as LoadingAnimation};
